import { Button } from "@aws-amplify/ui-react";
import { CTable } from "@coreui/react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import LocalizedStrings from "react-localization";

const SpareDocumentsTable = ({
  items,
  pagination,
  onNext,
  onPrevious,
}) => {
  const columns = [
    {
      key: "fileName",
      label: strings.table.headers.name,
      _style: { width: "80%" },
    },
    {
      key: "actions",
      label: "",
      _style: { width: "20%" },
    },
  ];

  return (
    <>
      <CTable
        className="table-centered"
        items={items}
        columns={columns}
        tableHeadProps={{ color: "light" }}
        responsive
        hover
      />
      <Button
        size="small"
        disabled={pagination.previous?.length <= 0}
        style={styles.buttonPrevious}
        onClick={onPrevious}
      >
        <FiArrowLeft /> {strings.table.pagination.buttonPrevious}
      </Button>
      <Button
        size="small"
        disabled={!pagination.nextToken}
        style={styles.buttonNext}
        onClick={onNext}
      >
        <FiArrowRight /> {strings.table.pagination.buttonNext}
      </Button>
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    table: {
      pagination: {
        buttonPrevious: "Atrás",
        buttonNext: "Siguiente",
      },
      headers: {
        name: "Nombre",
      },
    },
  },
});

const styles = {
  buttonPrevious: { marginLeft: "15px" },
  buttonNext: { float: "right", marginRight: "15px" },
};

export default SpareDocumentsTable;
